<template>
	<div class="contentbox">
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="" prop="appid">-->
						<!--<app-list @getAppId="getAppId" :appId="formInline.appId" :clear="'noclear'"></app-list>-->
					<!--</el-form-item>-->
                    <el-form-item label="方案名称：" prop="planName">
                        <el-input v-model="formInline.planName" placeholder="请输入方案名称" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
                    </el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<br/>
					<el-form-item>
						<el-button v-has="'adUnlockConfig:add'"  type="success" icon="el-icon-circle-plus-outline"  @click="addData">添加广告解锁方案</el-button>
					</el-form-item>
					<!-- <el-form-item label="是否自动播放广告" style="margin-left: 30px;">
						<el-switch
								v-model="playStatus"
								active-color="#13ce66"
								inactive-color="#ff4949" :active-value="1"
								:inactive-value="0" @change="setPlayAdStatus">
						</el-switch>
					</el-form-item> -->
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%"  height="100%" class="tableStyle">
					<el-table-column prop="programme" label="方案名称" width="300">
					</el-table-column>
					<el-table-column prop="svName" label="指定短剧" width="300">
						<template slot-scope="scope">
							<span v-if="scope.row.type == 0">通用</span>
							<span v-else>{{scope.row.svName}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="unlockInfo" label="广告解锁方案">
						<template slot-scope="scope">
							<span v-if="scope.row.type == 0">看广告解锁{{scope.row.unlockEps}}集</span>
							<ul>
								<li v-for="(item, index) in scope.row.unlockInfoVo" :key="index">
									第{{item.startEpNumber}}集开始，看广告解锁{{item.unlockEps}}集
								</li>
							</ul>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope" class="ddd">
							<el-button v-has="'adUnlockConfig:update'" type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
							<el-popover v-has="'adUnlockConfig:delete'" width="160" v-if="scope.row.type > 0" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
							<!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--添加-->
		<el-dialog :dialogTitle="dialogTitle" :visible.sync="dialogFormVisible" width="700px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" size="small" style="max-height: 480px;overflow: auto; padding-right: 80px;">
				<el-form-item label="方案名称：" prop="programme" placeholder="请输入方案名称">
					<el-input v-model="ruleForm.programme"></el-input>
				</el-form-item>
				<el-form-item label="指定短剧：" prop="svId" v-if="ruleForm.type != 0">
					<el-tag closable @close="handleCloseTagVideo" v-if="ruleForm.svName" style="margin-right: 10px;">{{ruleForm.svName}}</el-tag>
					<el-button type="primary" size="small" @click="isShowDialogVideo = true">选择</el-button>
					<el-input v-model="ruleForm.svId" style="display: none;"></el-input>
					<!--<p class="input-note">不选默认方案生效于全部短剧（兜底）</p>-->
				</el-form-item>
				<el-form-item v-if="ruleForm.type == 0">
					<div class="lock-div" style="margin-left: -80px;">
						<p class="title">解锁方案</p>
						<ul class="lock-box">
							<li>
								<span>看广告解锁</span>
								<el-form-item prop="unlockEps">
									<el-input type="number" v-model="ruleForm.unlockEps" placeholder="" min="0"></el-input>
								</el-form-item>
								<span>集</span>
							</li>
						</ul>
					</div>
				</el-form-item>
				<el-form-item v-else>
					<div class="lock-div" style="margin-left: -80px;">
						<p class="title">解锁方案</p>
						<ul class="lock-box">
							<li v-for="(item, index) in ruleForm.unlockInfoVo" :key="index">
								<span>第</span>
								<el-form-item :prop="'unlockInfoVo.' + index + '.startEpNumber'" :rules="rules.startEpNumber" :key="'unlockInfoVo.' + index + '.startEpNumber'">
									<el-input type="number" v-model="item.startEpNumber" min="1" disabled="disabled" v-if="index == 0"></el-input>
									<el-input type="number" v-model="item.startEpNumber" min="1" v-else></el-input>
								</el-form-item>
								<span>集开始，看广告解锁</span>
								<el-form-item :prop="'unlockInfoVo.' + index + '.unlockEps'" :rules="rules.unlockEps" :key="'unlockInfoVo.' + index + '.unlockEps'">
									<el-input type="number" v-model="item.unlockEps" placeholder="" min="0"></el-input>
								</el-form-item>
								<span>集</span>
								<i class="el-icon-circle-plus-outline" @click="addLockList()"></i>
								<i class="el-icon-remove-outline" v-if="ruleForm.unlockInfoVo.length > 1" @click="delLockList(index)"></i>
							</li>
						</ul>
						<div class="danger-text" style="margin-top: 20px; line-height: 28px;">
							<p>温馨提示</p>
							<p>优先级说明：指定剧配置 > 全部配置</p>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<video-table :visible.sync="isShowDialogVideo" :selectVideo="selectVideo" @videoSure="videoSure" @cancelDialogVideo="cancelDialogVideo" :appId="formInline.appId"></video-table>
	</div>
</template>
<script>
// import AppList from '@/components/AppList'
import VideoTable from '@/components/VideoTable'
import {listAd, details, addAd, delAd, getAdStatus, setAdStatus} from "@/api/dysvzk/app/ad";
import {validateIncreasingNumbers} from '@/utils/inCreasing'
export default {
    components: {
        // AppList,
        VideoTable
    },
    data() {
        var validateNum = (rule, value, callback) => {
            if (!(/(^[1-9]\d*$)/.test(value))) {
                return callback(new Error('数字应为正整数'));
            } else {
                callback();
            }
        };
        return {
            formInline: {
                appId: localStorage.getItem('appId'),
                planName:''
            },
            playStatus: '',
            dialogTitle: '添加广告解锁方案',
            tableData: {
                pageSize: 20,
                pageNo: 1,
                totalPage: 1,
                totalNum: 0,
                result: [
                ]
            },
            currentPage: 1,
            rowForm: {},
            dialogFormVisible: false,
            typeOptions: [ // 类型
                {
                    value: 1,
                    label: '普通'
                }
            ],
            styleOptions: [ // 样式
                {
                    value: 2,
                    label: '2*N'
                }
            ],
            ruleForm: {
                agentId: '',
                appId: '',
                clientId: '',
                id: null,
                programme: "",
                svId: '',
                svName: "",
                type: 1,
                unlockEps: '',
                unlockInfoVo: [
                    {
                        startEpNumber: null,
                        unlockEps: null
                    }
                ]
            },
            rules: {
                svId: [
                    {required: true, message: '请选择短剧', trigger: 'change'}
                ],
                programme: [
                    {required: true, message: '请输入方案名称', trigger: 'blur'}
                ],
                startEpNumber: [
                    {required: true, message: '请输入开始集数', trigger: 'blur'},
                    { validator: validateNum, trigger: 'blur' }
                ],
                unlockEps: [
                    {required: true, message: '请输入解锁集数', trigger: 'blur'},
                    { validator: validateNum, trigger: 'blur' }
                ],
            },
            isShowDialogVideo: false,
            selectVideo: {},
            dataIds: '', 	// 短剧ID
            moduleId: ''  // 组件ID

        }
    },
    computed: {},
    watch: {
    },
    mounted: function() {
        this.getTableData()
        this.getPlayAdStatus()
    },
    methods: {
        search () {
            this.currentPage = 1
            this.getTableData()
        },
        resetQuery() {
            this.$refs['formInline'].resetFields()
            this.getTableData()
            // console.log(formName)
            // this.$refs[formName].resetFields()
            // this.getTableData()
        },
        // 从组件获取appid
        getAppId(data) {
            this.formInline.appId = data
            this.getTableData()
            this.getPlayAdStatus()
        },
        // 关闭选剧弹窗
        cancelDialogVideo(data) {
            console.log('cancel')
            this.isShowDialogVideo = data
        },
        // 确定剧
        videoSure(data) {
            this.ruleForm.svName = data.videolistVo.svName
            this.ruleForm.svId = data.svId
            this.selectVideo = data
            this.ruleForm.unlockInfoVo[0].startEpNumber = data.userFreeEp + 1
        },
        // 删除所选剧
        handleCloseTagVideo(tag){
            console.log(tag)
            this.ruleForm.svName = ''
            this.ruleForm.svId = ''
            this.selectVideo = {}
            this.ruleForm.unlockInfoVo[0].startEpNumber = ''
        },
        // 添加解锁集数
        addLockList () {
            this.ruleForm.unlockInfoVo.push(
                {
                    startEpNumber: '',
                    unlockEps: ''
                }
            )
            // this.ruleForm.unlockInfoVo.push(
            // 	{
            //        startEpNumber: parseInt(start) + 1, 
            // 		unlockEps: ''
            // 	}
            // )
        },
        delLockList(index) {
            this.ruleForm.unlockInfoVo.splice(index, 1)
        },
        closeDialog(){
            this.$refs['ruleForm'].resetFields()
        },
        handleCurrentChange(value) {
            this.currentPage = value
            this.getTableData()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.tableData.pageSize  = val
            this.currentPage = 1
            this.getTableData()
        },
        handleLook(id) {
            // this.ruleForm = row
            this.dialogInfoVisible = true
            this.getDetails(id)
        },
        // 编辑
        handleEdit(id) {
            if (this.$refs['ruleForm'] !== undefined) {
                this.$refs['ruleForm'].resetFields()
            }
            this.dialogTitle = '编辑广告解锁方案'
            this.getDetails(id)
        },
        getDetails(id) {
            details({
                id: id
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.ruleForm = response.data.content
                    console.log(response.data.content.unlockInfoVo.length)
                    if (response.data.content.unlockInfoVo.length == 0) {
                        this.ruleForm.unlockInfoVo = [{
                            startEpNumber: null,
                            unlockEps: null
                        }]
                        console.log(this.ruleForm)
                    }
                    this.dialogFormVisible = true
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        addData() {
            this.dialogFormVisible = true
            this.dialogTitle = '添加广告解锁方案'
            this.selectVideo = {}
            this.ruleForm = {
                agentId: '',
                appId: this.formInline.appId,
                clientId: '',
                id: null,
                programme: "",
                svId: '',
                svName: "",
                type: 1,
                unlockEps: '',
                unlockInfoVo: [
                    {
                        startEpNumber: null,
                        unlockEps: null
                    }
                ]
            }
            if (this.$refs['ruleForm'] !== undefined) {
                this.$refs['ruleForm'].resetFields()
            }
        },
        // 弹框确定
        editDialogSureBtn (formName) {
            var that = this
            var unlockInfoVo = this.ruleForm.unlockInfoVo
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // var statrFlag = true
                    // unlockInfoVo.forEach((item, index) => {
                    // 	if (index > 0) {
                    //        console.log(parseInt(item.startEpNumber), parseInt(unlockInfoVo[index - 1].startEpNumber))
                    //        if (item.startEpNumber <= (unlockInfoVo[index - 1].startEpNumber)) {
                    //            statrFlag = false
                    //            that.$message.error('开始集数应依次增大');
                    //            return false
                    //        }   
                    // 	}
                    // })
                    // if (statrFlag) {
                    //    this.saveTableData()
                    // }
                    if (validateIncreasingNumbers(unlockInfoVo)) {
                        this.saveTableData()
                    } else {
                        that.$message.error('开始集数应依次增大');
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 保存编辑信息
        saveTableData () {
            addAd(this.ruleForm).then(response => {
                if (response.data.head.flag === 0) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.getTableData()
                    this.dialogFormVisible = false
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
        },
        handleDelete(id) {
            delAd({
                id: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    if (this.tableData.result.length === 1 && this.currentPage > 1) {
                        this.currentPage =  this.currentPage - 1
                    }
                    this.$refs[id].doClose()
                    this.getTableData()
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
        },
        getTableData() {
            let json2 = {
                pageNo: this.currentPage,
                pageSize: this.tableData.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            console.log(paramJson)
            listAd(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        getPlayAdStatus () {
            getAdStatus({
                appId: this.formInline.appId
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.playStatus = response.data.content.adStatus
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        setPlayAdStatus () {
            setAdStatus({
                appId: this.formInline.appId,
                status: this.playStatus
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.getPlayStatus()
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        }
    }
}
</script>
